"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCroppedImg = void 0;
var getCroppedImg = function getCroppedImg(image, cropArea) {
  return new Promise(function (resolve, reject) {
    var croppedImage = document.createElement('img');
    croppedImage.crossOrigin = 'anonymous';
    croppedImage.onload = function () {
      var canvas = document.createElement('canvas');
      var scaleX = croppedImage.naturalWidth / croppedImage.width;
      var scaleY = croppedImage.naturalHeight / croppedImage.height;
      canvas.width = cropArea.width;
      canvas.height = cropArea.height;
      var ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(croppedImage, cropArea.x * scaleX, cropArea.y * scaleY, cropArea.width * scaleX, cropArea.height * scaleY, 0, 0, cropArea.width, cropArea.height);

        // As a blob
        canvas.toBlob(function (blob) {
          if (blob) {
            resolve(blob);
          } else {
            reject(null);
          }
        }, 'image/jpeg', 1);
      } else {
        reject(null);
      }
    };
    croppedImage.src = image;
  });
};
exports.getCroppedImg = getCroppedImg;